import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
export class CliniqueFilter {
  clinique:  string;
  selected: boolean;
  index: number
  constructor(other?: Partial<CliniqueFilter>) {
    this.clinique = other?.clinique ||  "";
    this.selected = other?.selected || false;
    this.index = other?.index || 0
  }
}
@Component({
  selector: 'app-liste-clinique',
  templateUrl: './liste-clinique.component.html',
  styleUrls: ['./liste-clinique.component.css']
})
export class ListeCliniqueComponent implements OnInit {

 @Input() values: Array<any> = new Array();
  @Output() valuesChange: EventEmitter<any> = new EventEmitter();
  isChecked: boolean = false;
  cliniques: string = "";
  select: Array<CliniqueFilter> = []
  @Input() cliniquesSelected: Array<any> = new Array();
  @Output() cliniquesSelectedChange: EventEmitter<Array<CliniqueFilter>> = new EventEmitter();
  @Output() closed: EventEmitter<void> = new EventEmitter();

  constructor() { }

  ngOnInit(): void { }

changed(clinique: any, event, index): void {
    if (event.target.checked) {
        // For radio button, only keep one selection
        this.cliniquesSelected = [{ 
            clinique: clinique, 
            selected: true, 
            index: index 
        }];
    }
    
    this.cliniquesSelectedChange.emit(this.cliniquesSelected);
}

close(): void {
    this.cliniquesSelectedChange.emit(this.cliniquesSelected);
    this.closed.emit();
}
}
